<template>
  <div class="distributor-routing-page">
    <div class="page-header">
      <div>
        <h1>Маршруты ATI</h1>
        <p>Управление группами логистов, привязками направлений и ATI-аккаунтами для распределителя автопубликации.</p>
      </div>
    </div>

    <nav class="tabs" aria-label="Разделы маршрутов ATI">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        class="tab"
        :class="{ active: activeTab === tab.key }"
        :aria-pressed="activeTab === tab.key"
        @click="activeTab = tab.key"
      >
        {{ tab.label }}
        <span v-if="tab.badge !== null && tab.badge !== undefined" class="tab-badge">{{ tab.badge }}</span>
      </button>
    </nav>

    <section class="tab-panel">
      <groups-section v-show="activeTab === 'groups'" />
      <bindings-section v-show="activeTab === 'bindings'" :prefill="bindingPrefill" />
      <assignments-section
        v-show="activeTab === 'assignments'"
        :active="activeTab === 'assignments'"
        @alerts="setAlerts"
        @create-binding="onCreateBinding"
      />
      <problems-section
        v-show="activeTab === 'problems'"
        :active="activeTab === 'problems'"
        @total="setProblemsTotal"
      />
      <accounts-section v-show="activeTab === 'accounts'" />
    </section>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import GroupsSection from './distributor-routing/GroupsSection.vue'
import BindingsSection from './distributor-routing/BindingsSection.vue'
import AssignmentsSection from './distributor-routing/AssignmentsSection.vue'
import ProblemsSection from './distributor-routing/ProblemsSection.vue'
import AccountsSection from './distributor-routing/AccountsSection.vue'

export default {
  name: 'DistributorRoutingPage',
  components: { GroupsSection, BindingsSection, AssignmentsSection, ProblemsSection, AccountsSection },
  setup() {
    const activeTab = ref('groups')
    const alertsCount = ref(0)
    const problemsTotal = ref(null)
    const bindingPrefill = ref(null)

    const tabs = computed(() => [
      { key: 'groups', label: 'Группы' },
      { key: 'bindings', label: 'Привязки' },
      {
        key: 'assignments',
        label: 'Выложенные грузы',
        badge: alertsCount.value > 0 ? alertsCount.value : null,
      },
      {
        key: 'problems',
        label: 'Проблемы публикации',
        badge: problemsTotal.value,
      },
      { key: 'accounts', label: 'ATI-аккаунты' },
    ])

    const setAlerts = (count) => {
      alertsCount.value = count
    }

    const setProblemsTotal = (count) => {
      problemsTotal.value = Number.isFinite(Number(count)) ? Number(count) : 0
    }

    const onCreateBinding = (data) => {
      bindingPrefill.value = { ...data, _nonce: Date.now() }
      activeTab.value = 'bindings'
    }

    return { activeTab, tabs, setAlerts, setProblemsTotal, bindingPrefill, onCreateBinding }
  },
}
</script>

<style scoped>
.distributor-routing-page {
  background: #f5f7fb;
  min-height: 100vh;
  padding: 24px;
  color: #1f2937;
}

.page-header {
  margin-bottom: 18px;
}

.page-header h1 {
  color: #1f2937;
  font-size: 26px;
  font-weight: 700;
  margin: 0 0 4px;
}

.page-header p {
  color: #6b7280;
  font-size: 13px;
  margin: 0;
}

.tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 16px;
  overflow-x: auto;
}

.tab {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  color: #6b7280;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 16px;
  transition: background-color 0.15s ease, color 0.15s ease;
  white-space: nowrap;
}

.tab:hover {
  background: #eff6ff;
  color: #2563eb;
}

.tab.active {
  border-bottom-color: #2563eb;
  color: #2563eb;
}

.tab-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 7px;
  border-radius: 10px;
  background: #fee2e2;
  color: #991b1b;
  font-size: 11px;
  font-weight: 700;
}

.tab-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
  padding: 18px;
}

:deep(.section button) {
  transition: filter 0.15s ease;
}

:deep(.section button:not(:disabled):hover) {
  filter: brightness(0.96);
}

:deep(.section button:not(:disabled):active) {
  filter: brightness(0.92);
}

@media (max-width: 720px) {
  .distributor-routing-page { padding: 14px; }
  .page-header h1 { font-size: 22px; }
  .tab { padding: 10px 12px; }
  .tab-panel { padding: 12px; }
}
</style>
